
export default function PublicitySection() {
  const mediaOutlets = [
    { name: 'Entrepreneur', url: 'https://entrepreneur.com' },
    { name: 'Markets Insider', url: 'https://markets.businessinsider.com' },
    { name: 'The Star', url: 'https://thestar.com' },
    { name: 'Manchester Evening News', url: 'https://manchestereveningnews.co.uk' },
    { name: 'Gulf Times', url: 'https://gulf-times.com' },
    { name: 'US Business News', url: 'https://usbusinessnews.com' }
  ];

  return (
    <section id="publicity" className="py-20 bg-gradient-to-br from-gray-50 via-amber-50/30 to-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Guaranteed <span className="text-transparent bg-clip-text bg-gradient-to-r from-amber-600 via-yellow-500 to-amber-700">Publicity</span>
          </h2>
          <div className="w-24 h-1 bg-gradient-to-r from-amber-500 via-yellow-400 to-amber-600 mx-auto mb-8 shadow-sm"></div>
          <p className="text-xl text-gray-700 max-w-3xl mx-auto leading-relaxed">
            We secure placements in <span className="text-amber-700 font-semibold">top global media outlets</span> to amplify your brand's voice and establish <span className="text-transparent bg-clip-text bg-gradient-to-r from-amber-600 to-yellow-600 font-medium">industry authority</span>.
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div className="relative">
            <div className="absolute inset-0 bg-gradient-to-br from-amber-100/20 to-yellow-100/20 rounded-xl transform rotate-1"></div>
            <img 
              src="https://static.readdy.ai/image/c02e1238a9e0afa048eae5bb36a2fc1c/bda6bcc9adebcb5fd6fa6577b388c59d.png" 
              alt="Media Coverage" 
              className="relative rounded-xl shadow-xl object-cover object-top w-full h-80 border-2 border-amber-100/50"
            />
          </div>
          <div>
            <h3 className="text-2xl font-bold text-gray-900 mb-8">
              Featured <span className="text-transparent bg-clip-text bg-gradient-to-r from-amber-600 to-yellow-600">Media Outlets</span>
            </h3>
            <div className="grid grid-cols-2 gap-4">
              {mediaOutlets.map((outlet, index) => (
                <a 
                  key={index}
                  href={outlet.url} 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="bg-gradient-to-br from-white via-amber-50/20 to-white rounded-lg p-4 shadow-md hover:shadow-lg transition-all duration-300 hover:transform hover:scale-105 cursor-pointer text-center border border-amber-100/30 hover:border-amber-200/50"
                >
                  <div className="relative mb-3">
                    <div className="absolute inset-0 bg-gradient-to-br from-amber-200/30 to-yellow-200/30 rounded-full transform scale-110"></div>
                    <div className="relative w-8 h-8 bg-gradient-to-r from-amber-500 to-amber-600 rounded-full flex items-center justify-center mx-auto shadow-lg">
                      <i className="ri-newspaper-line text-white text-sm"></i>
                    </div>
                  </div>
                  <p className="font-semibold text-gray-900 text-sm hover:text-amber-800 transition-colors">{outlet.name}</p>
                </a>
              ))}
            </div>
            <div className="mt-8 relative">
              <div className="absolute inset-0 bg-gradient-to-r from-amber-100/10 to-yellow-100/10 rounded-xl transform -rotate-1"></div>
              <div className="relative bg-gradient-to-br from-white via-amber-50/30 to-white p-6 rounded-xl shadow-lg border border-amber-100/50">
                <div className="flex items-center mb-4">
                  <div className="relative mr-4">
                    <div className="absolute inset-0 bg-gradient-to-br from-amber-200/40 to-yellow-200/40 rounded-lg transform scale-110"></div>
                    <div className="relative w-12 h-12 bg-gradient-to-r from-amber-500 to-amber-600 rounded-lg flex items-center justify-center shadow-lg">
                      <i className="ri-trophy-line text-white text-xl"></i>
                    </div>
                  </div>
                  <div>
                    <h4 className="font-bold text-gray-900">
                      Proven <span className="text-transparent bg-clip-text bg-gradient-to-r from-amber-600 to-yellow-600">Results</span>
                    </h4>
                    <p className="text-gray-600">
                      <span className="text-amber-700 font-semibold">100+</span> successful media placements
                    </p>
                  </div>
                </div>
                <p className="text-gray-700">
                  Our strategic approach ensures your brand gets the <span className="text-amber-700 font-medium">visibility</span> it deserves in <span className="text-transparent bg-clip-text bg-gradient-to-r from-amber-600 to-yellow-600 font-medium">top-tier publications</span>.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
